var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('span',{attrs:{"id":`${_vm.id}`}},[_vm._v(" "+_vm._s(_vm.value ? _vm.huggedText(_vm.value, 20) : '-')+" ")]),(_vm.value && _vm.value.length > 20)?_c('b-tooltip',{attrs:{"target":`${_vm.id}`,"placement":"topright"}},[_c('span',[_vm._v(_vm._s(_vm.value))])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }